import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import axios from "axios";
import { marked } from 'marked';
import Title from 'context/title';
import "./legal.css";

class Page extends Component {
  constructor(props) {
    super(props);

    this.state = {
      content: null
    };

    this.loadContent();
  }

  componentDidMount() {
    Title.set(this.title());
  }

  // Default hook for subclasses that forget to override it. Title.set(null) drops the part and
  // falls through to Title.setRoot(), so a missing title() degrades to "BlobHub" instead of
  // throwing in componentDidMount and blanking the page.
  title() {
    return null;
  }

  loadContent() {
    axios.get(this.contentPath())
      .then( response => {
        this.setState({ content: {__html: marked.parse(response.data)} });
      }, error => {
      });
  }

  render() {
    return (
      <>
        <Container className="blob-header-row content-row">
          <Row>
            <Col className="legal-content" dangerouslySetInnerHTML={this.state.content}>
            </Col>
          </Row>
        </Container>
      </>
    );
  }
}

export class Cookies extends Page {
  contentPath() {
    return "/static/legal/cookies.md";
  }

  title() {
    return "Cookie Policy";
  }
}

export class Terms extends Page {
  contentPath() {
    return "/static/legal/terms.md";
  }

  title() {
    return "Terms of Use";
  }
}

export class Privacy extends Page {
  contentPath() {
    return "/static/legal/privacy.md";
  }

  title() {
    return "Privacy Policy";
  }
}

export class Beta extends Page {
  contentPath() {
    return "/static/legal/beta.md";
  }

  title() {
    return "Beta Terms and Conditions";
  }
}
